import type { FolderForestNode } from 'owa-favorites-types';
import { getStore } from '../store/store';

export default function getSelectedNode(): FolderForestNode {
    return getStore().selectedNode;
}
